import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ContactModel } from 'src/app/core/models/contact/contact.model';
import { ContactModalComponent } from 'src/app/shared/modals/contact-modal/contact-modal.component';
import { EntityTypeEnum } from '../../enums/entity-type-id-enum';


@Injectable({
  providedIn: 'root'
})
export class ContactModalService {


  @Output() modelChanged = new EventEmitter<any>();

  constructor(private modalService: NgbModal) { }

  openModal(model?: any, other?: any, disableEditing?: boolean, entityType?: EntityTypeEnum) {
    var modalRef!: NgbModalRef;
    if (model == null) {
      model = new ContactModel();
    }
    if (entityType == undefined) {
      entityType = EntityTypeEnum.Account;
    }

    modalRef = this.modalService.open(ContactModalComponent, { windowClass: "customModalClassUnderName", size: 'lg', centered: false, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.model = model;
    if (disableEditing != undefined) {
      modalRef.componentInstance.disableInputs = disableEditing;
    }
    modalRef.componentInstance.passedContactId = other;
    modalRef.componentInstance.entityTypeId = entityType;

    var sub: Subscription = modalRef.closed.subscribe(() => {
      this.modelChanged.emit(modalRef.componentInstance.model);
      sub.unsubscribe();
    })
  }

}
